// Copyright (c) 2016 Deere & Company

import busyCounter from '../../../../shared/reducers/busy-counter';
import claim from './claim';
import {combineReducers} from 'redux';
import confirmationModal from './confirmation-modal';
import createClaimModal from './create-claim-modal';
import customer from './customer';
import formValidation from './form-validation';
import isActionButtonDisabled from './is-action-button-disabled';
import isCopied from './is-copied';
import isEditable from './is-editable';
import isStickyHeaderVisible from './is-sticky-header-visible';
import mccQuestions from './mcc-questions';
import methodOfContactOptions from './method-of-contact-options';
import product from './product-details';
import questionsRequiredOptions from './questions-required-options';
import relationshipOptions from './relationship-options';
import temporaryObjectKey from './temporary-object-key';
import warrantyStatusModal from './warranty-status-modal';

export const getCombinedReducers = () => combineReducers({
    busyCounter,
    claim,
    confirmationModal,
    createClaimModal,
    customer,
    formValidation,
    isActionButtonDisabled,
    isCopied,
    isEditable,
    isStickyHeaderVisible,
    mccQuestions,
    methodOfContactOptions,
    product,
    questionsRequiredOptions,
    relationshipOptions,
    temporaryObjectKey,
    warrantyStatusModal
});



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-customer-followup/reducers/index.js